import useSubtitle from 'src/hooks/useSubtitle';
import useUI from 'src/hooks/useUI';
import SubtitleControl from 'src/themes/cosmos/components/SubtitleControl';
import { SETTING_CONTAINERS as SETTING_CONTAINER_NAME } from 'src/interfaces/enums';
import useSettingsOverlay from '../../hooks/useSettingsOverlay';

const SubtitleControlContainer = () => {
  const { setContainerName } = useSettingsOverlay();
  const { hideSettings } = useUI();
  const { activeTrack, setSubtitle, subtitles, toggleSubtitle, subtitleEnabled } = useSubtitle();
  return (
    subtitles && (
      <SubtitleControl
        subtitles={subtitles}
        activeSubtitle={subtitleEnabled ? activeTrack : null}
        onChange={(subtitle) => {
          setSubtitle(subtitle.language);
          hideSettings();
        }}
        onDisable={() => {
          if (subtitleEnabled) {
            toggleSubtitle();
            hideSettings();
          }
        }}
        onClickSubtitleStyle={() => {
          setContainerName(SETTING_CONTAINER_NAME.SUBTITLE_STYLE);
        }}
      />
    )
  );
};

export default SubtitleControlContainer;
